import React from "react";
import "./spinner.css";

interface SpinnerProps {
  white?: boolean;
}

export const Spinner: React.FC<SpinnerProps> = ({ white }) => {
  return (
    <div className="custom-spinner-container">
      <div className={`custom-spinner${white ? " white" : ""}`} />
    </div>
  );
};

export const SpinnerScreen: React.FC = () => {
  return (
    <div className="custom-spinner-page">
      <Spinner white={true} />
    </div>
  )
}